export interface AEMImage {
  alt?: string;
  src?: string;
  label?: string;
  url?: string;
}
